export default __webpack_public_path__ + "static/media/warrior2.7d2a45ef.jpg";